import React from 'react';

import { EXPIRE_KEYS, type ExpireOption } from '@pkg/hooks';

import { Item, type ItemProps } from './Item';

import { List, StyledMenu } from './Menu.style';

export interface MenuProps {
    selected?: ExpireOption;
    onSelect: ItemProps['onSelect'];
}

export function Menu({ selected = 'week', onSelect }: MenuProps) {
    const itemsMarkup = EXPIRE_KEYS.map((key) => (
        <Item
            key={`ExpireSelector-Menu-Item-${key}`}
            expiration={key}
            disabled={key === selected}
            pressed={key === selected}
            onSelect={onSelect}
        />
    ));

    return (
        <StyledMenu>
            <List>{itemsMarkup}</List>
        </StyledMenu>
    );
}
